import Image from 'next/image';

import { Button, PicturePasswordPreview } from '../';

import { PicturePasswordItem } from './shared';

import styles from './PicturePassword.module.scss';

interface PicturePasswordInputProps {
  password: string[];
  setPassword: (newPassword: string[]) => void;
  disabled?: boolean;
  translate(str: string, key: string): string;
  items: PicturePasswordItem[];
}

export const PicturePasswordInput = ({
  password,
  setPassword,
  translate,
  items,
  disabled = false,
}: PicturePasswordInputProps) => {
  const addSymbolToPassword = (v: string) => {
    setPassword([...password, v]);
  };
  return (
    <div className={styles.container}>
      <div className={styles.preview}>
        <PicturePasswordPreview password={password.map((value) => items.find((i) => i.value === value)!)} size={48} />
      </div>
      <div className={styles.buttons}>
        {items.map((item) => (
          <PictureButton item={item} password={password} addItem={addSymbolToPassword} disabled={disabled} />
        ))}
      </div>
      <Button onClick={() => setPassword([])} disabled={disabled}>
        {translate('Clear', 'clear')}
      </Button>
    </div>
  );
};

interface PictureButtonProps {
  item: PicturePasswordItem;
  password: string[];
  addItem: (value: string) => void;
  disabled: boolean;
}

const PictureButton = ({ password, addItem, item, disabled }: PictureButtonProps) => {
  const isDisabled = password.includes(item.value) || disabled;

  return (
    <Button onClick={() => addItem(item.value)} disabled={isDisabled} className={styles.button} variant="tonal">
      <Image alt={item.altText} src={item.imageUrl} width={96} height={96} />
    </Button>
  );
};
